module.exports = __webpack_public_path__ + "static/media/5.a2a94271.png";